import { ROUTES } from '@/constants/routes/default';
import { cn } from '@/helpers/common';
import Logo from '@/components/svgs/cn/logo';
import Link from 'next/link';

const FooterCN = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex md:px-10 max-md:px-4 py-4 min-h-30 border-t border-black3">
      <div className="max-w-270 w-full h-full max-sm:block sm:flex justify-between items-center m-auto flex-wrap gap-4">
        <div>
          <Logo className="w-35 h-4 shrink-0" />
          <p className="text-sm text-black1 mt-1.5">© All Rights Reserved</p>
        </div>

        <ul
          className={cn(
            'max-w-112.5 grid gap-y-2 gap-x-20 list-disc marker:text-black1',
            'max-sm:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 max-sm:gap-x-8 sm:gap-x-20 max-sm:ml-4 sm:ml-0 max-sm:mt-2 sm:mt-0',
          )}
        >
          <li key="home">
            <Link
              className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
              href={ROUTES.home}
            >
              Home
            </Link>
          </li>
          {/* <li key="contact-us">
            <Link
              className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
              href={ROUTES.contactUs}
            >
              Contact Us
            </Link>
          </li> */}
          <li key="terms">
            <Link
              className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
              href={ROUTES.termsOfUse}
            >
              Terms of Use
            </Link>
          </li>
          {isAuthorized ? (
            <li key="account">
              <Link
                className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
                href={ROUTES.profile}
              >
                Account
              </Link>
            </li>
          ) : (
            <li key="login">
              <Link
                className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
                href={ROUTES.signin}
              >
                Login
              </Link>
            </li>
          )}
          <li key="private">
            <Link
              className="text-jelly-bean font-bold text-sm hover:text-black1 default-transition"
              href={ROUTES.privacyPolicy}
            >
              Privacy Policy
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default FooterCN;
